<template>
  <div v-if="hasLoad" class="buy-list-page">
    <template v-if="buyList.length > 0">
      <div
        v-for="(item, index) in buyList"
        :key="index"
        class="buy-item"
        @click="goDetail(item)"
      >
        <div class="name-wraper">
          <div class="name">{{ item.typeDesc }}</div>
          <div class="status-wrapper">
            <span :class="['status' + item.status]">{{ item.statusName }}</span>
            <IconFont name="mc-icon-arrowright" color="#8C8C8C" size="10px" />
          </div>
        </div>
        <div class="date-time">有效期：{{ item.endTime }}</div>
        <div class="buy-time">购买时间：{{ item.ct }}</div>
        <div class="pay-price">
          支付金额：<span class="price">{{ item.price }}</span>
        </div>
      </div>
      <p class="desc-text">仅支持查看近一年内的购买记录</p>
    </template>
    <!-- 暂无商品 -->
    <empty
      v-if="buyList.length === 0"
      :desc="'暂无一年内的购买记录'"
      :type="1"
      :img="'DefaultEmpty'"
      class="empty-box"
    ></empty>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import empty from '@/common/layout/empty/index'
import { API } from '@/api'
export default {
  components: {
    empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '购买记录'
      navBar.setTitle({
        text: '购买记录'
      })
      vm.getOrderList()
    })
  },
  data() {
    return {
      buyList: [],
      hasLoad: false
    }
  },
  methods: {
    async getOrderList() {
      try {
        const resData = await API.primeCard.primeCardOrderList()
        this.buyList = resData
        this.hasLoad = true
      } catch (e) {
        this.hasLoad = true
      }
    },
    goDetail(item) {
      this.$track(this.$trackMap.memberBuyLIst.goDetail)
      this.$router.push({
        name: 'memberBuyDetail',
        query: {
          orderId: item.orderId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.buy-list-page {
  height: 100vh;

  padding: 0.16rem 0.24rem;

  background-color: #f5f5f5;
  overflow-y: auto;
  .buy-item {
    margin-bottom: 0.16rem;
    padding: 0.24rem;

    background-color: #fff;
    border-radius: 0.24rem;
    .name-wraper {
      @include flex-row-between;
      .name {
        @include text(0.32rem, #262626, true);
      }
      .status-wrapper {
        font-size: 0.26rem;
        @include flex-row-center;
        .status2 {
          color: #15bb5c;
        }
        .status3 {
          color: #8c8c8c;
        }
        .status4 {
          color: #ff9d21;
        }
      }
    }
    .date-time,
    .buy-time,
    .pay-price {
      margin-top: 0.08rem;

      line-height: 0.4rem;
      @include text(0.28rem, #8c8c8c);
    }

    .pay-price {
      .price {
        color: #f03100;
      }
    }
  }
  .desc-text {
    margin-top: 0.32rem;

    line-height: 0.4rem;
    text-align: center;
    @include text(0.28rem, #8c8c8c);
  }
}
</style>
